import { HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetAllSemestersFromEntityUseCaseInterface } from 'domain/usecases';

export class RemoteGetAllSemestersFromEntity
  implements GetAllSemestersFromEntityUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: GetAllSemestersFromEntityUseCaseInterface.Params,
  ): Promise<GetAllSemestersFromEntityUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      url: generateUrl(this.url, params),
      method: 'get',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
